export default "__VITE_ASSET__BAwIwo_v__"